import { FC } from 'react';
import { NavTabsProps } from '../model/NavTabsProps';
import { HeaderNav } from './HeaderNav';
import { NavTabsComponent } from './NavTabsComponent';

type Props = NavTabsProps & {
  id?: string;
};

export const HeaderNavTabsComponent: FC<Props> = ({ id, ...navTabsProps }) => (
  <HeaderNav id={id}>
    <NavTabsComponent {...navTabsProps} />
  </HeaderNav>
);
